var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeiconsTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.25,97.18c6.8,9.73,94.37,134.98,98.88,141.43h0s75.19,107.56,75.19,107.56h37.82c-45.53-65.12-128.94-184.43-174.07-248.99h-37.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.4,1.95H41.2C19,1.95,1,19.95,1,42.15v358.2c0,22.2,18,40.2,40.2,40.2h358.2c22.2,0,40.2-18,40.2-40.2V42.15c-.1-22.2-18.1-40.2-40.2-40.2ZM276.74,363.86l-76.09-110.74-95.26,110.74h-24.62l108.96-126.64L80.76,78.64h83.1l72.05,104.86,90.21-104.86h24.62l-103.89,120.77h0l113,164.44h-83.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeiconsTwitter);
export default __webpack_public_path__ + "static/media/freeicons-twitter.853910251029850fa060ab622a408607.svg";
export { ForwardRef as ReactComponent };